import { sync } from "vuex-pathify"

export default {
  computed: {
    excludedRetention: {
      get() {
        return Math.floor(this.excludedRetentionSeconds / 86400)
      },
      set(val) {
        this.excludedRetentionSeconds = val * 86400
      },
    },
    excludedSource: {
      get() {
        return this.excludedEventSources[0]
      },
      set(val) {
        this.excludedEventSources = [val]
      },
    },
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }

    Object.assign(this.$options.computed, {
      ...sync(
        `${storeNamespace}/model@audience.template.rule.exclusions.rules[0]`,
        {
          excludedEventSources: "eventSources",
          excludedRetentionSeconds: "retentionSeconds",
        }
      ),
      ...sync(
        `${storeNamespace}/model@audience.template.rule.exclusions.rules[0].filter.filters[0]`,
        {
          excludedPage: "value",
        }
      ),
    })
  },
}
